// extracted by mini-css-extract-plugin
export var checked = "InputButton-module--checked--3f138";
export var checkmark = "InputButton-module--checkmark--59ee3";
export var fadeInAnimation = "InputButton-module--fadeInAnimation--fd7f8";
export var icon = "InputButton-module--icon--2c02c";
export var input = "InputButton-module--input--b03ec";
export var inputButton = "InputButton-module--inputButton--27eca";
export var tile = "InputButton-module--tile--44800";